<script>
export default {
  name: 'PaymentMethod',
  props: ['paymentMethod'],
  computed: {
    isCreditCard() {
      return Boolean(this.paymentMethod.card)
    },
    isSepaDebit() {
      return Boolean(this.paymentMethod.sepa_debit)
    },
  },
}
</script>

<template>
  <div>
    <div
      v-if="isCreditCard"
      class="credit-card"
      :class="{
        mastercard: paymentMethod.card.brand === 'mastercard',
        visa: paymentMethod.card.brand === 'visa',
      }"
    >
      <div class="credit-card-last4">{{ paymentMethod.card.last4 }}</div>
      <div class="credit-card-expiry">
        {{ paymentMethod.card.exp_month }}/{{ paymentMethod.card.exp_year }}
      </div>
    </div>
    <div v-if="isSepaDebit" class="sepa-debit">
      <div class="sepa-debit-last4">
        <span class="sepa-debit-hidden">
          {{ paymentMethod.sepa_debit.country + '**' }}
          {{ paymentMethod.sepa_debit.bank_code }}
          {{ paymentMethod.sepa_debit.branch_code }}
          **** ****
        </span>
        {{ paymentMethod.sepa_debit.last4 }}
      </div>
      <div class="sepa-debit-logo">
        <svg
          viewBox="0 0 25 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          role="presentation"
          focusable="false"
          class="p-Logo p-Logo--md p-TabIcon TabIcon p-TabIcon--selected TabIcon--selected"
        >
          <path
            d="M22.761 0H1.982l-.216.004a3.14 3.14 0 0 0-.47.041A1.5 1.5 0 0 0 .192.85a1.58 1.58 0 0 0-.147.447 3.116 3.116 0 0 0-.041.47A10.61 10.61 0 0 0 0 1.982v12.036c0 .072.002.144.004.216.004.157.013.315.041.47a1.496 1.496 0 0 0 .804 1.104c.143.072.29.119.447.147.155.028.313.037.47.041l.216.003.257.001h20.778l.217-.004c.156-.004.314-.013.47-.04.157-.03.304-.075.447-.148a1.492 1.492 0 0 0 .657-.657c.073-.143.119-.29.147-.447.028-.155.037-.313.041-.47l.003-.216.001-.256V1.982l-.004-.216a3.126 3.126 0 0 0-.041-.47 1.507 1.507 0 0 0-1.25-1.251 3.15 3.15 0 0 0-.471-.041A10.787 10.787 0 0 0 23.017 0h-.256Z"
            fill="#10298D"
          ></path>
          <path
            d="M22.761.533h.253l.205.004c.12.003.26.01.39.033.113.02.208.051.3.098a.966.966 0 0 1 .423.424c.046.09.077.185.098.299.023.129.03.27.033.39.002.068.002.135.003.205v12.03l-.003.204c-.004.12-.01.26-.034.39a.964.964 0 0 1-.521.722c-.09.047-.186.078-.298.098-.133.024-.279.03-.389.033-.069.002-.137.003-.208.003H1.985c-.07 0-.138-.001-.204-.003a2.709 2.709 0 0 1-.39-.033 1.05 1.05 0 0 1-.3-.098.958.958 0 0 1-.423-.423 1.047 1.047 0 0 1-.098-.3c-.024-.13-.03-.27-.033-.39a9.968 9.968 0 0 1-.003-.204V1.985c0-.068 0-.136.003-.205.003-.119.01-.259.033-.39.02-.113.051-.208.098-.3A.962.962 0 0 1 1.09.669c.091-.047.186-.078.3-.098.13-.023.27-.03.39-.033l.204-.003h20.776"
            fill="#10298D"
          ></path>
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M21.14 9.905h-2.064l-.279 1.008h-1.596l1.722-5.833h2.332L23 10.913h-1.564l-.295-1.008Zm-.307-1.136L20.11 6.24l-.703 2.529h1.426Zm-7.85 2.144V5.08h2.878c.395 0 .696.033.903.098.473.151.79.46.953.926.084.245.126.613.126 1.106 0 .592-.046 1.016-.138 1.276-.185.511-.565.806-1.138.883-.068.011-.355.021-.861.03l-.257.009h-.921v1.505h-1.544Zm1.545-2.859h.963c.305-.011.49-.035.558-.072.091-.051.152-.154.182-.307.02-.102.03-.253.03-.454 0-.247-.02-.43-.059-.55-.055-.167-.188-.269-.399-.306-.1-.008-.2-.01-.3-.008h-.975v1.697ZM6.666 6.941H5.229c0-.24-.029-.4-.083-.482-.086-.122-.322-.182-.707-.182-.376 0-.625.035-.746.104-.121.07-.182.223-.182.458 0 .212.054.352.161.419a.677.677 0 0 0 .307.084l.29.02c.388.024.776.054 1.163.089.492.05.847.183 1.068.398.174.167.278.388.311.658.02.162.028.345.028.55 0 .469-.043.813-.131 1.031-.16.4-.52.652-1.08.759-.234.044-.591.066-1.074.066-.805 0-1.366-.048-1.683-.147-.387-.118-.644-.362-.768-.728C2.033 9.836 2 9.498 2 9.021h1.438v.122c0 .253.071.416.215.488a.82.82 0 0 0 .359.08h.528c.27 0 .44-.014.516-.042a.428.428 0 0 0 .26-.255c.021-.074.033-.167.033-.282 0-.256-.092-.412-.277-.469-.069-.022-.39-.053-.961-.092a11.565 11.565 0 0 1-.956-.096c-.47-.09-.785-.274-.94-.553-.139-.237-.208-.596-.208-1.076 0-.366.038-.66.112-.88a.956.956 0 0 1 .36-.503c.241-.176.552-.279.93-.31.347-.029.695-.043 1.044-.042.603 0 1.033.035 1.29.105.625.171.937.65.937 1.435 0 .065-.004.16-.014.29Z"
            fill="#fff"
          ></path>
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M10.792 5.86c.659 0 1.246.303 1.633.777l.344-.736a3.022 3.022 0 0 0-2.079-.821 2.992 2.992 0 0 0-2.776 1.832h-.671l-.397.847h.863a2.89 2.89 0 0 0 .005.526h-.435l-.396.848h1.051a2.993 2.993 0 0 0 2.756 1.78 3.03 3.03 0 0 0 1.682-.505V9.37a2.105 2.105 0 0 1-3.34-.236h2.2l.396-.848h-2.92a2.162 2.162 0 0 1-.013-.526h3.179l.396-.847h-3.3a2.106 2.106 0 0 1 1.822-1.052Z"
            fill="#FFCC02"
          ></path>
        </svg>
      </div>
    </div>
  </div>
</template>

<style scoped>
/* MAIN CREDIT CARD CONTAINER */
.sepa-debit,
.credit-card {
  border-radius: 8px;
  max-width: 270px;
  position: relative;
  transition: all 0.4s ease;
  box-shadow: 0 2px 4px 0 #cfd7df;
  min-height: 90px;
  padding: 13px;
  background: #1a1b1c;
  color: #efefef;
}

.sepa-debit {
  max-width: 400px;
  background: #0b1616;
}

/*  NUMBER FORMATTING */
.sepa-debit-last4,
.credit-card-last4 {
  font-family: 'PT Mono', Helvetica, sans-serif;
  font-size: 24px;
}

.credit-card-last4:before {
  content: '**** **** **** ';
  color: #4f4d4d;
  font-size: 20px;
}

.sepa-debit-hidden {
  color: #4f4d4d;
  font-size: 20px;
}

.credit-card-expiry {
  font-family: 'PT Mono', Helvetica, sans-serif;
  font-size: 18px;
  position: absolute;
  bottom: 8px;
  left: 15px;
}

/* BRAND CUSTOMIZATION */
.credit-card.visa {
  background: #4862e2;
  color: #eaeef2;
}

.credit-card.visa .credit-card-last4:before {
  color: #8999e5;
}

.credit-card.mastercard {
  background: #4f0cd6;
  color: #e3e8ef;
}

.credit-card.mastercard .credit-card-last4:before {
  color: #8a82dd;
}

/*   LOGOS  */
.credit-card::after {
  content: ' ';
  position: absolute;
  bottom: 10px;
  right: 15px;
}

.credit-card.visa::after {
  height: 16px;
  width: 50px;
  background-image: url('data:image/png;base64,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');
}

.credit-card.mastercard::after {
  width: 40px;
  height: 25px;
  background-image: url('data:image/png;base64,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');
}

.sepa-debit-logo {
  width: 48px;
  height: 32px;
  position: absolute;
  right: 12px;
  bottom: 8px;
}
</style>
